import React from 'react';
import { Link } from 'react-router-dom';

import './remtitle.scss'


function RemTitle(props) {
    const { title } = props;

    return (
        <div className="heading-respp-intro left-common-div-intro left-common-div" style={{marginBottom:"-80px",backgroundColor:"black"}}>
            <div data-aos="fade-right" data-aos-duration="900">
                <h2 className='f-w-700 text-shadow intro-main-heading' style={{ color: "white" }}>Roadmap </h2>
                <div className="intro-divider"></div>
                <div className="subheading-div">
                    <h4 className='f-w-700 text-shadow intro-subheading' style={{ color: "white" }}>Roadmap for public sales</h4>
                </div>
            </div>
        </div>
    );
}

export default RemTitle;